import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import {
  Button,
  message,
  Upload,
  Modal,
  Image,
  Form,
  Input,
  TimePicker,
  Table,
  Popconfirm,
  Switch,
  Select,
  Checkbox,
} from "antd";
import imageCompression from "browser-image-compression";
import moment from "moment";
import "./General.css";
import Swal from "sweetalert2";
import {
  DeleteOutlined,
  EditOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import CloseButton from "../components/CloseButton";
import currencyData from "../locale/currency/CurrencyCode.json"; // adjust path as needed
import { useCurrency } from "../contexts/ValidationContext";
import config from "../config";

const Generals = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;

  const [imageLogo, setImageLogo] = useState(null);
  const [editLogo, setEditLogo] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [fileUpload, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  //##### Printer #####
  const [printersData, setPrintersData] = useState([]);
  const [printerModal, setPrinterModal] = useState(false);
  const [editPrinter, setEditPrinter] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');



  const { Code: currencyMap } = currencyData;
  const { currency, updateCurrency } = useCurrency();
  const [showPrefix, setShowPrefix] = useState(false);
  const [videoList, setVideoList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const columns = [
    {
      title: "No",
      key: "index",
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
      ), // Show continuous row number across paginated pages
      width: 60,
    },
    {
      title: "Printer Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: false,
      width: 180,
    },
    { title: "IP Address", dataIndex: "ip_address", width: 160 },
    { title: "Paper Width", dataIndex: "paper_size", width: 120 },
    {
      title: "Counter Printer",
      dataIndex: "is_counter",
      render: (is_counter) => (is_counter ? "Yes" : "No"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.is_counter === value,
      width: 140,
    },
    {
      title: "Actions",
      dataIndex: "_id",
      render: (id, record) => (
        <div className="action-icons">
          <EditOutlined
            style={{ cursor: "pointer", fontSize: 22, marginRight: 10 }}
            onClick={() => openPrinterModal(record)}
          />
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ cursor: "pointer", fontSize: 22, marginLeft: 8 }} />
          </Popconfirm>
        </div>
      ),
      width: 120,
    },
  ];

  const openPrinterModal = (printer = null) => {
    if (printer) {
      setEditPrinter(printer); // Set the printer to edit
    } else {
      setEditPrinter(null); // For adding a new printer
    }

    setPrinterModal(true); // Open the modal
  };


  const handleDelete = async (record) => {
    try {
      await axios.post(`${apiBaseUrl}/api/settings/delete-printer`, {
        id: record.id,
      });

      // message.success('Printer Deleted Successfully');
      Swal.fire({
        title: "Deleted!",
        text: "Printer Deleted Successfully",
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      getSetting();
      setPrinterModal(false);
    } catch (error) {
      // message.error('Something Went Wrong');
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  const handleCancel = async () => {
    setLoading(false);
    setEditPrinter(null); // Clear the edit state
    setPrinterModal(false); // Close the modal
    // }
  };

  const handlePrinterSubmit = async (values) => {
    setLoading(true);
    const { name, ip_address, port, paper_size, is_counter } = values;
    let api = "";
    if (editPrinter) {
      api = `${apiBaseUrl}/api/settings/edit-printer`;
    } else {
      api = `${apiBaseUrl}/api/settings/add-printer`;
    }

    try {
      if (editPrinter) {
        await axios.put(api, {
          id: editPrinter.id,
          name: name,
          ip_address: ip_address,
          port: port,
          paper_size: paper_size,
          is_counter: is_counter,
        });
      } else {
        await axios.post(api, {
          name: name,
          ip_address: ip_address,
          port: port,
          paper_size: paper_size,
          is_counter: is_counter,
        });
      }
      // message.success("Printer Added Successfully");
      Swal.fire({
        title: "Success",
        text:
          "Printer " + (editPrinter ? "updated" : "added") + " successfully",
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setPrinterModal(false);
      getSetting();
    } catch (error) {
      // message.error('Something Went Wrong');
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something Went Wrong",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
    setLoading(false);
  };
  //##### Printer #####

  const [form] = Form.useForm();

  const getSetting = async () => {
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/settings/get-settings`
      );

      if (data && data.image) {
        setImageLogo(data.image);
        setEditLogo(data.image);
        form.setFieldsValue({
          name: data.name || "",
          registration_id: data.registration_id || "",
          phone: data.phone || "",
          addressLine1: data.address?.addressLine1 || "",
          addressLine2: data.address?.addressLine2 || "",
          postalCodeCity: data.address?.postalCodeCity || "",
          stateCountry: data.address?.stateCountry || "",
          operatingHours: [
            moment(data.operatingHours?.start, "HH:mm"),
            moment(data.operatingHours?.end, "HH:mm"),
          ],
          sentToKitchenToggle: data.sentToKitchenToggle,
          isSendSeperatedOrderChit: data.isSendSeperatedOrderChit,
          isAccessKeyNeeded: data.isAccessKeyNeeded,
          deliverDisableToggle: data.deliverDisableToggle,
          invoicePrefixToggle: data.invoicePrefixToggle,
          invoicePrefix: data.invoicePrefix || "",
          invoiceSuffix: data.invoiceSuffix || "",
          invoicePrefixNumber: data.invoicePrefixNumber || "",
          currencyCode: data.currencyCode,
          wifiId: data.wifiId || "",
          wifiPassword: data.wifiPassword || "",

        });
        updateCurrency(data.currencyCode);
      } else {
        // default logo
        setImageLogo(
          "https://bucketergroup.s3.ap-southeast-1.amazonaws.com/posfolder/logo.png"
        );
      }
      console.log("data.printerSettings: ", data.printerSettings);

      setPrintersData(data.printerSettings || []);
    } catch (error) {
      // message.error("Something Went Wrong");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load settings",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  useEffect(() => {
    console.log("imageUrl", imageUrl);
    console.log("fileUpload", fileUpload);
    console.log("fileList", fileList);
    console.log("editLogo", editLogo);
    console.log("imageLogo", imageLogo);
  }, [imageUrl, fileUpload, fileList, editLogo, imageLogo]);

  //   useEffect(() => {
  //     if (editLogo && editLogo.image) {
  //       const extractedFilename = editLogo.image.match(/[^/]+$/)[0];
  //       setImageUrl(editLogo.image);
  //       setFileList([
  //         {
  //           uid: "-1",
  //           name: extractedFilename,
  //           status: "done",
  //           url: editLogo.image,
  //         },
  //       ]);
  //     }
  //   }, [editLogo]);

  const handleImageUpload = async (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      // message.error("Invalid file type. Only JPG, JPEG, and PNG are allowed.");
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text: "Only JPG, JPEG, and PNG are allowed",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      // message.error("File size exceeds 20MB limit. Please choose a smaller file.");
      Swal.fire({
        icon: "error",
        title: "File Too Large",
        text: "File size exceeds 20MB limit",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    setIsUploading(true);
    setFileList([
      {
        uid: file.uid,
        name: file.name,
        status: "uploading",
      },
    ]);

    try {
      const compressedFile = await imageCompression(file, {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      });

      const localUrl = URL.createObjectURL(compressedFile);
      setImageUrl(localUrl);
      setFile(compressedFile);

      setFileList([
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: localUrl,
        },
      ]);
      setIsUploading(false);
    } catch (error) {
      // message.error("Image compression failed.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Image compression failed",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setIsUploading(false);
    }
  };

  const uploadImageToS3 = async (file) => {
    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await axios.post(
        `${apiBaseUrl}/api/image/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data && response.data.url) {
        // message.success("Image uploaded successfully!");
        return response.data.url;
      } else {
        throw new Error("Failed to upload image. Please try again.");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      throw error;
    }
  };

  const handleSubmit = async (values) => {
    if (isUploading) {
      //   message.warning("Please wait until the upload is complete before submitting.");
      //   return;
    }

    setLoading(true);
    const { name, registration_id, phone, addressLine1, addressLine2, postalCodeCity, stateCountry, 
      operatingHours, sentToKitchenToggle, deliverDisableToggle, invoicePrefixToggle, invoicePrefix, 
      invoiceSuffix, invoicePrefixNumber, isSendSeperatedOrderChit, isAccessKeyNeeded, currencyCode, 
      wifiId, wifiPassword
    } = values;

    const address = {
      addressLine1,
      addressLine2,
      postalCodeCity,
      stateCountry,
    };

    try {
      if (!editLogo) {
        var uploadedImageUrl = "";
        if (!fileUpload) {
          //   message.error("Please upload an image before submitting.");
          //   setLoading(false);
          //   return;
          uploadedImageUrl =
            "https://bucketergroup.s3.ap-southeast-1.amazonaws.com/posfolder/logo.png";
        } else {
          uploadedImageUrl = await uploadImageToS3(fileUpload);
        }

        await axios.post(`${apiBaseUrl}/api/settings/add-settings`, {
          image: uploadedImageUrl,
          name,
          address,
          operatingHours: {
            start: operatingHours[0].format("HH:mm"),
            end: operatingHours[1].format("HH:mm"),
          },
        });
        // message.success("Restaurant Details Added Successfully");
        Swal.fire({
          title: "Success",
          text: "Restaurant details added successfully",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        let updatedImageUrl = editLogo.image;
        if (imageUrl !== editLogo.image && fileUpload) {
          updatedImageUrl = await uploadImageToS3(fileUpload);
        } else if (imageLogo === editLogo.image && !fileUpload) {
          updatedImageUrl = editLogo.image;
        } else if (!imageLogo && !editLogo.image) {
          updatedImageUrl =
            "https://bucketergroup.s3.ap-southeast-1.amazonaws.com/posfolder/logo.png";
        }

        await axios.put(`${apiBaseUrl}/api/settings/edit-settings`, {
          image: updatedImageUrl,
          name,
          registration_id,
          phone,
          address,
          operatingHours: {
            start: operatingHours[0].format("HH:mm"),
            end: operatingHours[1].format("HH:mm"),
          },
          sentToKitchenToggle: sentToKitchenToggle,
          isSendSeperatedOrderChit: isSendSeperatedOrderChit,
          isAccessKeyNeeded: isAccessKeyNeeded,
          deliverDisableToggle: deliverDisableToggle,
          invoicePrefixToggle: invoicePrefixToggle,
          invoicePrefixNumber,
          invoicePrefix,
          invoiceSuffix,
          currencyCode: currencyCode,
          wifiId: wifiId,
          wifiPassword: wifiPassword,
        });
        // message.success("Restaurant Details Updated Successfully");
        Swal.fire({
          title: "Success",
          text: "Restaurant details updated successfully",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }

      //   setEditLogo({ image: updatedImageUrl });
      form.resetFields();
    } catch (error) {
      // message.error("Something Went Wrong");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
      getSetting();
      setFile(null);
      setImageUrl(null);
      setFileList([]);
    }
  };

  const validateAddressLine1 = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject("Address line 1 is required.");
    }
    return Promise.resolve();
  };

  const validatePostalCodeCity = (_, value) => {
    const postalCodeCity = value || "";
    if (!postalCodeCity.trim()) {
      return Promise.reject("Postal code and city are required.");
    }

    // const postalCodeRegex = /^[0-9]{5}$/;
    // const postalCode = postalCodeCity.split(" ")[0];  // Assuming postal code comes before the city name
    // if (!postalCodeRegex.test(postalCode)) {
    //   return Promise.reject("Invalid postal code format.");
    // }

    return Promise.resolve();
  };

  const validateStateCountry = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject("State and country are required.");
    }
    return Promise.resolve();
  };

  //   const handleDeleteLogo = async () => {
  //     try {
  //       const confirmDelete = window.confirm("Are you sure you want to delete the logo?");
  //       if (!confirmDelete) return;

  //       setIsDeleting(true);
  //       await axios.post(`${apiBaseUrl}/api/logo/delete-logo`, {});
  //       message.success("Logo deleted successfully");
  //       setImageLogo(null);
  //       setEditLogo(null);
  //       setImageUrl(null);
  //       setFileList([]);
  //       setFile(null);
  //     } catch (error) {
  //       console.error("Error deleting logo:", error);
  //       message.error("Something went wrong. Please try again later.");
  //     } finally {
  //       setIsDeleting(false);
  //     }
  //   };

  useEffect(() => {
    fetch(`${apiBaseUrl}/api/videos`)
      .then(res => res.json())
      .then(data => setVideoList(data));
  }, []);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    console.log('upload', selectedFile);
    if (!selectedFile) return;
    setUploading(true);
    setErrorMessage(''); // Clear previous errors

    const formData = new FormData();
    formData.append('video', selectedFile);

    try {
      const response = await fetch(`${apiBaseUrl}/api/videos/upload`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        // Parse backend error message
        const errorData = await response.json();
        setErrorMessage(errorData.error || 'Upload failed');
        return; // Stop further execution if error
      }

      // On success: refresh video list
      const res = await fetch(`${apiBaseUrl}/api/videos`);
      const data = await res.json();
      setVideoList(data);
      setSelectedFile(null);

    } catch (err) {
      console.error('Upload failed', err);
      setErrorMessage('Network error, please try again.');
    } finally {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setUploading(false);
    }
  };


  const handleVideoDelete = async (filename) => {
    const fileOnly = filename.split('/').pop();
    const confirmed = window.confirm(`Delete ${fileOnly}?`);
    if (!confirmed) return;

    try {
      const response = await fetch(`${apiBaseUrl}/api/videos/${encodeURIComponent(fileOnly)}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.error || 'Delete failed');
        return;
      }

      setVideoList(videoList.filter(v => !v.endsWith(fileOnly)));
    } catch (err) {
      console.error('Delete failed', err);
      alert('Network error while deleting video');
    }
  };



  return (
    <DefaultLayout showSearch={false}>
      <div className={`general-page-wrapper${printerModal ? ' blur-background' : ''}`}>
        <div className="page-header">
          <h1 className="page-title">General</h1>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="general-form"
          initialValues={{
            name: "",
            address: "",
            //   operatingHours: [moment("00:00", "HH:mm"), moment("23:59", "HH:mm")],
            operatingHours: "",
          }}
        >
          <Form.Item
            label="Restaurant Name"
            name="name"
            rules={[
              { required: true, message: "Please enter the restaurant name" },
            ]}
          >
            <Input className="input_1" placeholder="Enter restaurant name" />
          </Form.Item>

          <Form.Item
            label="Registration Number"
            name="registration_id"
            rules={[
              { message: "Please enter the registration id" },
            ]}
          >
            <Input className="input_1" placeholder="Enter registration id" />
          </Form.Item>
          <Form.Item
            label="Contact Number"
            name="phone"
            rules={[
              { message: "Please enter the contact number" },
            ]}
          >
            <Input className="input_1" placeholder="Enter contact number" />
          </Form.Item>

        <Form.Item label="Address" required>
          <Input.Group>
            <Form.Item
              name="addressLine1"
              rules={[{ required: true, validator: validateAddressLine1 }]}
              noStyle
            >
              <Input className="input_1" placeholder="Enter address line 1" />
            </Form.Item>
            <Form.Item name="addressLine2" noStyle>
              <Input
                className="input_1"
                placeholder="Enter address line 2 (optional)"
              />
            </Form.Item>
            <Form.Item
              name="postalCodeCity"
              rules={[{ required: true, validator: validatePostalCodeCity }]}
              noStyle
            >
              <Input
                className="input_1"
                placeholder="Enter postal code and city"
              />
            </Form.Item>
            <Form.Item
              name="stateCountry"
              rules={[{ required: true, validator: validateStateCountry }]}
              noStyle
            >
              <Input
                className="input_1"
                placeholder="Enter state and country"
              />
            </Form.Item>
          </Input.Group>
        </Form.Item>

        <Form.Item
          label="Operating Hours"
          name="operatingHours"
          rules={[{ required: true, message: "Please select operating hours" }]}
        >
          <TimePicker.RangePicker format="HH:mm" />
        </Form.Item>
        {/* <Form.Item
          name="sentToKitchenToggle"
          valuePropName="checked"
          label="Send to Kitchen"
          tooltip="When checked, orders will be sent to the kitchen automatically."
        >
            <Switch />
        </Form.Item> */}
{/* 
         <Form.Item
            label="Deliver Disable"
            name="deliverDisableToggle"
            valuePropName="checked"
            tooltip="When checked, the order can skip the 'Delivered' step and proceed directly to checkout."
          >
          <Switch />
        </Form.Item> */}

        {/* <Form.Item 
              name="isSendSeperatedOrderChit" 
              valuePropName="checked" 
              label="Print Order Chit Item By Item" 
              tooltip="When checked, order chit will be printed item by item."
            >
            <Switch />
        </Form.Item> */}

        {/* <Form.Item
          label="Use Own Invoice Prefix"
          name="invoicePrefixToggle"
          valuePropName="checked"
          tooltip="Use this option to enable a custom invoice prefix."
        >
          <Switch />
        </Form.Item> */}
      
        {/* <Form.Item
          label="Use Own Invoice Prefix"
          name="invoicePrefixToggle"
          valuePropName="checked"
          tooltip="Use this option to enable a custom invoice prefix."
        >
          <Switch 
          // onChange={(checked) => setShowPrefix(checked)} 
          />
        </Form.Item> */}

        {/* {showPrefix && (
          <>
            <Form.Item
              label="Invoice Prefix"
              name="invoicePrefix"
              rules={[{ required: true, message: 'Please enter an invoice prefix' }]}
            >
              <Input placeholder="e.g. INV123456" />
            </Form.Item>
          </>
        )} */}

        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => 
          prevValues.invoicePrefixToggle !== currentValues.invoicePrefixToggle
        }>
          {({ getFieldValue }) => 
            getFieldValue('invoicePrefixToggle') ? (
              <Form.Item
                label="Invoice Prefix"
                name="invoicePrefix"
                rules={[{ required: true, message: 'Please enter an invoice prefix' }]}
              >
                <Input placeholder="e.g. INV" />
              </Form.Item>
            ) : null
          }
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => 
          prevValues.invoicePrefixToggle !== currentValues.invoicePrefixToggle
        }>
          {({ getFieldValue }) => 
            getFieldValue('invoicePrefixToggle') ? (
               <Form.Item
                label="Invoice Prefix Number"
                name="invoicePrefixNumber"
                rules={[{ required: true, message: 'Please enter an invoice prefix number' }]}
              >
                <Input placeholder="e.g. 123456" />
              </Form.Item>
            ) : null
          }
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => 
          prevValues.invoicePrefixToggle !== currentValues.invoicePrefixToggle
        }>
          {({ getFieldValue }) => 
            getFieldValue('invoicePrefixToggle') ? (
              <Form.Item
                label="Invoice Suffix"
                name="invoiceSuffix"
                // rules={[{ required: true, message: 'Please enter an invoice suffix' }]}
              >
                <Input placeholder="e.g. AA-21" />
              </Form.Item>
            ) : null
          }
        </Form.Item>

          <Form.Item name="currencyCode" label="Currency Code">
            <Select
              placeholder="Select currency code"
              onChange={value => {
                updateCurrency(value);
                localStorage.setItem('currencyCode', value);
              }}
            >
              {Object.entries(currencyMap).map(([code, symbol]) => (
                <Select.Option key={code} value={code}>
                  {code} ({symbol})
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Upload Logo">
            <Upload
              listType="picture"
              fileList={fileList}
              customRequest={({ file }) => handleImageUpload(file)}
              onRemove={() => {
                setFile(null);
                setFileList([]);
                setImageUrl(null);
              }}
            >
              {fileList.length < 1 && (
                <Button icon={<UploadOutlined />} className="upload-image-button">Upload Image</Button>
              )}
            </Upload>
            {imageLogo && (
              <div style={{ marginTop: "10px" }}>
                <div>Current Used Logo:</div>
                <Image
                  src={imageLogo}
                  alt="Restaurant Logo"
                  style={{ width: "180px", height: "auto", marginBottom: "15px" }}
                />
                {/* <Button
              type="danger"
              onClick={handleDeleteLogo}
              loading={isDeleting}
              disabled={isDeleting}
            >
              Delete Logo
            </Button> */}
              </div>
            )}
          </Form.Item>

          <Form.Item
            label="Wifi SSID"
            name="wifiId"
            // rules={[
            //   { message: "Please enter the registration id" },
            // ]}
            dependencies={['wifiPassword']} // Re-validates when password changes
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value && getFieldValue('wifiPassword')) {
                    return Promise.reject(new Error('Wifi SSID is required'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input className="input_1" placeholder="Enter Wifi SSID" />
          </Form.Item>

          <Form.Item
            label="Wifi Password"
            name="wifiPassword"
            // rules={[
            //   { message: "Please enter the contact number" },
            // ]}
            dependencies={['wifiId']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value && getFieldValue('wifiId')) {
                    return Promise.reject(new Error('Wifi Password are required'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input className="input_1" placeholder="Enter Wifi Password" />
          </Form.Item>

          <div className="bottom-right-container">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading || isUploading}
              >
                {editLogo ? "Update Details" : "Add Details"}
              </Button>
            </Form.Item>
          </div>
        </Form>

        <div
          style={{
            padding: '30px',
            maxWidth: '800px',
            margin: '0 auto',
            backgroundColor: '#fff',
            borderRadius: '10px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            fontFamily: 'Arial, sans-serif',
            color: '#333',
          }}
        >
          <h2 style={{ color: '#FF6B00', marginBottom: '20px' }}>📁 Video Manager</h2>

          <div
            style={{
              border: '2px dashed #FFA64D',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept="video/*"
              onChange={(e) => {
                handleFileChange(e);
              }}
              style={{
                marginBottom: '10px',
                border: '1px solid #ddd',
                padding: '8px',
                width: '100%',
                borderRadius: '6px',
              }}
            />
            <button
              onClick={handleUpload}
              disabled={uploading || !selectedFile}
              style={{
                backgroundColor: '#FF6B00',
                color: '#fff',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '6px',
                cursor: uploading || !selectedFile ? 'not-allowed' : 'pointer',
                opacity: uploading || !selectedFile ? 0.6 : 1,
              }}
            >
              {uploading ? 'Uploading...' : 'Upload Video'}
            </button>
            {errorMessage && (
              <div style={{
                backgroundColor: '#ffe6e6',
                color: '#cc0000',
                padding: '10px',
                marginTop: '15px',
                marginBottom: '15px',
                borderRadius: '5px',
                border: '1px solid #cc0000',
                textAlign: 'center'
              }}>
                ❌ {errorMessage}
              </div>
            )}
          </div>

          <h4 style={{ borderBottom: '2px solid #FFA64D', paddingBottom: '8px' }}>
            🎞️ Current Videos
          </h4>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
              gap: '20px',
              marginTop: '20px',
            }}
          >
            {(Array.isArray(videoList) ? videoList : []).map((videoUrl, idx) => {
              const filename = videoUrl.split('/').pop();
              return (
                <div
                  key={idx}
                  style={{
                    border: '1px solid #eee',
                    borderRadius: '8px',
                    padding: '10px',
                    textAlign: 'center',
                    backgroundColor: '#fff',
                  }}
                >
                  <video
                    src={`${apiBaseUrl}${videoUrl}`}
                    width="100%"
                    height="120"
                    style={{ borderRadius: '6px', objectFit: 'cover' }}
                    muted
                    preload="metadata"
                  />
                  <div style={{ marginTop: '10px', fontSize: '14px', color: '#555' }}>
                    {filename}
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    <a
                      href={`${apiBaseUrl}${videoUrl}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        fontSize: '13px',
                        color: '#FF6B00',
                        marginRight: '10px',
                        textDecoration: 'none',
                      }}
                    >
                      View
                    </a>
                    <button
                      onClick={() => handleVideoDelete(videoUrl)}
                      style={{
                        background: '#fff',
                        border: '1px solid #FF6B00',
                        color: '#FF6B00',
                        padding: '4px 10px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        cursor: 'pointer',
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>



        <div className="page-header mt-5">
          <h1 className="page-title">Printer List</h1>
          <Button type="primary" onClick={() => openPrinterModal()}>
            Add Printer
          </Button>
        </div>

        <Table columns={columns} dataSource={printersData} bordered
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            pageSizeOptions: ['10', '20', '50'],
            showSizeChanger: printersData.length > 10,
            showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
            onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
          }}
        />
      </div>
      {printerModal && (
        <Modal
          title={
            <div>
              {editPrinter !== null ? "Edit Printer" : "Add New Printer"}

              <CloseButton onClick={handleCancel} />
            </div>
          }
          open={printerModal}
          onCancel={handleCancel}
          footer={false}
        >
          <Form
            layout="vertical"
            initialValues={editPrinter}
            onFinish={handlePrinterSubmit}
          >
            <Form.Item
              name="name"
              label="Printer Name"
              rules={[
                { required: true, message: "Please input the printer name!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="ip_address"
              label="IP Address"
              rules={[
                {
                  required: true,
                  message: "Please input the printer ip address!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="is_counter"
              valuePropName="checked"
              label="Is Counter Printer?"
              tooltip="When checked, it means this printer is a counter printer."
            >
              <Switch />
            </Form.Item>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
              When checked, it means this printer is a counter printer.
            </div>
            <Form.Item
              name="paper_size"
              label="Paper Width in mm"
              rules={[
                { required: true, message: "Please input the paper width!" },
              ]}
              initialValue={editPrinter ? editPrinter.paper_size : 76}
            >
              <Input type="number" />
            </Form.Item>

            <Form.Item
              name="port"
              label="Port"
              rules={[{ required: true, message: "Please input the port!" }]}
              initialValue={editPrinter ? editPrinter.port : 9100}
            >
              <Input type="number" />
            </Form.Item>

            <div className="d-flex justify-content-end ant-modal-footer">
              {/* <Button type="primary" htmlType="submit">
                  Save
                </Button> */}
              <Button
                type="primary"
                htmlType="submit"
                loading={loading} // Show loading spinner
                iconPosition="start" // Ensure the icon is positioned at the start
                disabled={loading} // Disable the button while loading
              >
                Save
              </Button>
            </div>
          </Form>
        </Modal>
      )}

    </DefaultLayout>
  );
};

export default Generals;
